import style from "./Seleccion.module.css"
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { getUser, editarPerfil } from "../../actions";
import logo from "../../assets/Logo.svg"
import filled from "../../assets/filled.png"
import Swal from "sweetalert2";

export default function Listo() {
    const dataUserString = localStorage.getItem("dataUser");
    let usuario = {};

    try {
        usuario = dataUserString && dataUserString !== "undefined"
            ? JSON.parse(dataUserString)
            : {};
    } catch (error) {
        console.error("Error al parsear dataUser:", error);
        usuario = {};
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const continuar = async () => {
        try {
            const response = await dispatch(editarPerfil(usuario.id, usuario))

            // Verificar que la respuesta sea válida antes de guardar
            if (response && !response.name?.includes("Error")) {
                localStorage.setItem("dataUser", JSON.stringify(response))
                navigate("/home")
            } else {
                throw new Error("Error al actualizar el perfil")
            }
        } catch (error) {
            console.error("Error en continuar:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Hubo un problema al guardar tu información. Por favor, intenta de nuevo.",
            });
        }
    }

    const onClickHome = () => {
        navigate("/")
    }

    return (
        <div className={style.container}>
            <div className={style.general}>
                <div className={style.contLogo}>
                    <img className={style.logo} src={logo} alt="Big Sport Data" />
                </div>
                <div className={style.listo}>
                    <div className={style.interL}>
                        <img className={style.filled} src={filled} alt="success" />
                        <h1 className={style.regNameL}>TODO LISTO</h1>
                        <div className={style.conText}>
                            <span className={style.linkTextL}>
                                Gracias por completar tu información de usuario. Te damos la bienvenida a Big Sport Data
                            </span>
                        </div>
                        <button onClick={() => continuar()} className={style.btn}>
                            Continuar
                        </button>
                    </div>
                </div>
                <p className={style.copyright}>© 2024. Big Sport Data Todos los derechos reservados.</p>
            </div>
        </div>
    )
}